module.exports = __webpack_public_path__ + "img/screen-bezel.048df409.svg";